import React, { createContext, useState, useEffect, useContext } from 'react';
import { attractionsApi } from '../api/client';

const AttractionsContext = createContext();

export function AttractionsProvider({ children }) {
  const [attractions, setAttractions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAttractions();
  }, []);

  async function loadAttractions() {
    try {
      setLoading(true);
      setError(null);
      
      // Backend returns attractions with fully resolved image URLs
      const data = await attractionsApi.list();
      
      setAttractions(data || []);
    } catch (err) {
      setError(`Failed to load attractions: ${err.message}`);
      console.error("Error fetching attractions:", err);
    } finally {
      setLoading(false);
    }
  }

  const value = {
    attractions,
    loading,
    error,
    refreshAttractions: loadAttractions
  };

  return (
    <AttractionsContext.Provider value={value}>
      {children}
    </AttractionsContext.Provider>
  );
}

export function useAttractions() {
  const context = useContext(AttractionsContext);
  if (!context) {
    throw new Error('useAttractions must be used within an AttractionsProvider');
  }
  return context;
}
